// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceBar_price__b724x","priceText":"PriceBar_priceText__3CmV_"};